import { useState } from "react";

const initialsOf = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("") || "P";

/** The assistant's photo on a trip, or their initials when there is none. */
export default function TripAvatar({ name, image, size = "h-12 w-12" }) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={`${size} flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#f2dfe9] text-sm font-semibold text-[#6b0c44]`}
    >
      {image && !failed ? (
        <img
          src={image}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initialsOf(name)
      )}
    </div>
  );
}
